import * as yup from "yup";

import { UserSummary } from "@/model/User/UserSummary";

export const EditCourseSessionValidation = (trainerOptions: UserSummary[]) => {
	const ids = trainerOptions.map((x) => x.Id);

	return yup.object().shape({
		TrainerId: yup
			.number()
			.required("Select a trainer")
			.oneOf(ids, "Select a trainer"),
	});
};
